export default "__VITE_PUBLIC_ASSET__238311e5__"